<p-panel *ngIf="formReady">
  <app-reactive-form-builder
    [form]="formFields"
    [id]="getRegisterId()"
    [request]="request"
    [getRequest]="getRequest"
    [undoEnabled]="undoEnabled"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [dropdownsFinalized]="dropdownsFinalized"
    (goBack)="goBack()">
  </app-reactive-form-builder>
</p-panel>
